import React, { Fragment, useMemo } from 'react';
import styled from 'styled-components';
import { Link } from '@material-ui/core';

import { JiraApiPropertyRef } from '../JiraConnect.interface';

const StyledLink = styled(Link)`
  cursor: pointer;
  text-decoration: underline;
`;

export interface JiraReferenceTypeLinksProps {
  refs: JiraApiPropertyRef[] | undefined;
  onClick?: (schemaKey: string) => void;
}

const JiraReferenceTypeLinks: React.FC<JiraReferenceTypeLinksProps> = (
  props: JiraReferenceTypeLinksProps
) => {
  const { refs, onClick } = props;

  const links: React.ReactNode = useMemo(() => {
    if (!refs || refs.length === 0) {
      return null;
    }

    const lastIndex: number = refs.length - 1;
    return refs.map((ref: JiraApiPropertyRef, index: number) => {
      const { $ref: url } = ref;
      const [, type = ''] = url.split('components/schemas/');
      return !type ? null : (
        <Fragment key={`${url}-${index}`}>
          <StyledLink onClick={() => onClick?.(type)}>
            <code>{type}</code>
          </StyledLink>
          {index !== lastIndex ? ', ' : ''}
        </Fragment>
      );
    });
  }, [refs, onClick]);

  return <>{links}</>;
};

export default JiraReferenceTypeLinks;
